export default __webpack_public_path__ + "static/media/FRAME.14e28d88.png";